import useWindowDimensions from './useWindowDimensions';
import { breakpoints } from '../components/ui/breakpoints';

export default function useBreakpoint() {
  const { width } = useWindowDimensions();
  const down = name => width != null && width <= breakpoints[name];
  return { width, down };
}
